import { Card, IconButton, LuIcon, Text } from "@overmap-ai/blocks"
import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react"
import { cx } from "class-variance-authority"
import { memo, useCallback } from "react"

import { modelIconMapping } from "../../../mappings/icons"
import { useEditorEditable } from "../../hooks"

export const NotFoundAttachmentNode = memo((props: NodeViewProps) => {
	const { selected, deleteNode, editor } = props

	const isEditable = useEditorEditable(editor)

	const handleDelete = useCallback(() => {
		deleteNode()
		editor.commands.focus()
	}, [deleteNode, editor.commands])

	return (
		<NodeViewWrapper className="flex justify-center py-1">
			<Card
				className={cx("w-full", {
					"outline-(--primary-indicator) outline-2 -outline-offset-1":
						selected && editor.isEditable && editor.isFocused,
				})}
				size="sm"
			>
				<div className="flex h-max w-full items-center justify-between">
					<Text accentColor="base" size="sm">
						Attachment does not exist
					</Text>
					{isEditable && (
						<IconButton
							aria-label="delete"
							onClick={handleDelete}
							accentColor="base"
							size="sm"
							variant="ghost"
						>
							<LuIcon icon={modelIconMapping.close} />
						</IconButton>
					)}
				</div>
			</Card>
		</NodeViewWrapper>
	)
})
NotFoundAttachmentNode.displayName = "NotFoundAttachmentNode"
